/**
 * Form steps Circle script
 */
class ME_StepsCircleForm {
    constructor() {
        this.initState();
    }

    initState() {
        this.stepsCircleForm = $('.js-form-steps-circle');

        if (!this.stepsCircleForm || !this.stepsCircleForm.length) {
            return
        }

        this.btnNext = this.stepsCircleForm.find('.next-step');
        this.btnPrev = this.stepsCircleForm.find('.prev-step');
        this.steps = this.stepsCircleForm.find('.step');
        this.inputBook = this.stepsCircleForm.find('.step-1').find('.input.book');
        this.submitBtn = this.stepsCircleForm.find('.submit-form-btn');
        this.currentStep = 1;
        this.initEvents();
    }

    initEvents() {
        for (let i = 0; i < this.inputBook.length; i++) {
            this.inputBook.eq(i).on('input', e => {
                let value = parseInt(e.target.value, 10);

                if (value === 0) {
                    $('.activator strong').text('Wybierz podręcznik, z którego zamierzasz skorzystać');
                    $('.step-1 .validation-error').text('Wpisz deklarowaną wartość chociaż dla jednego podręcznika');
                } else if (value >= 1) {
                    $('.activator strong').text('Dodaj kolejny podręcznik, z którego zamierzasz korzystać');
                    $('.step-1 .validation-error').text('');
                }
            });
        }

        this.btnNext.on('click', (e) => {
            e.preventDefault();
            if (this.currentStep === 1) {
                // let formHelper = new ME_FormHelper(this.stepsCircleForm.find('.step-1'));
                // let resultStep1 = formHelper.formValidate();
                let step1 = document.querySelector('.step-1');

                if (step1.querySelectorAll('.input.book').length > 0) {
                    step1.querySelectorAll('.input.book').forEach(input => {

                        input.addEventListener('click', function () {
                            step1.querySelector('.validation-error').innerHTML = '';
                        })

                        if (input.value === "" || input.value === undefined || input.value <= "0" || input.value === null) {
                            this.currentStep = 1;
                            step1.querySelector('.validation-error').innerHTML = 'Wpisz deklarowaną wartość chociaż dla jednego podręcznika';
                        } else {
                            this.currentStep++;
                            let stepbar = $('body').find('.steps.with-circle-number');
                            stepbar.find('.stepbar-2').addClass('active');
                            step1.querySelector('.validation-error').innerHTML = '';
                            $('.step-1').removeClass('active');
                            $('.step-2').addClass('active');
                        }
                    })
                } else {
                    this.currentStep++;
                    let stepbar = $('body').find('.steps.with-circle-number');
                    stepbar.find('.stepbar-2').addClass('active');
                    step1.querySelector('.validation-error').innerHTML = '';
                    $('.step-1').removeClass('active');
                    $('.step-2').addClass('active');
                }

                // if (resultStep1) {
                //     setTimeout(() => {
                //         step1.querySelector('.validation-error').classList.remove('hidden')
                //         step1.querySelector('.validation-error').innerHTML = 'Wpisz deklarowaną wartość chociaż dla jednego podręcznika';
                //     }, 1000);

                //     step1.querySelectorAll('.input.book').forEach(input => {

                //         input.addEventListener('click', function () {
                //             step1.querySelector('.validation-error').innerHTML = '';
                //         })

                //         if (input.value === "" || input.value === undefined || input.value <= "0" || input.value === null) {
                //             this.currentStep = 1;
                //             step1.querySelector('.validation-error').innerHTML = 'Wpisz deklarowaną wartość chociaż dla jednego podręcznika';
                //         } else {
                //             this.currentStep++;
                //              let stepbar = $('body').find('.steps.with-circle-number');
                                // stepbar.find('.stepbar-2').addClass('active');
                                // $('.step-1').removeClass('active');
                                // $('.step-2').addClass('active');
                //         }
                //     })
                // }
                if (document.querySelector('.js-form-steps-circle').querySelectorAll('.effect input').length > 0) {
                    document.querySelector('.js-form-steps-circle').querySelectorAll('.effect input').forEach(input => {
                        if (input.value === 0 || input.value === "" || input.value === null) {
                            input.classList.remove('focus');
                        } else {
                            input.classList.add('focus');
                        }
                    })
                }
            }

            // if (this.currentStep === 2) {
            //     let formHelper = new ME_FormHelper(this.stepsCircleForm.find('.step-2'));
            //     let resultStep2 = formHelper.formValidate();

            //     if (resultStep2) {
            //         this.currentStep++;
            //         this.displayStep(this.currentStep)
            //     }
            // }
        });

        this.btnPrev.on('click', (e) => {
            e.preventDefault();

            this.currentStep = 1;
            let stepbar = $('body').find('.steps.with-circle-number');
            let step1 = $('.step-1');
            stepbar.find('.stepbar-2').removeClass('active');
            this.steps.removeClass('active');
            step1.addClass('active');
            setTimeout(() => {
				step1.find('.validation-error').html();
			}, 0);

            if (document.querySelector('.js-form-steps-circle').querySelectorAll('.effect input').length > 0) {
                document.querySelector('.js-form-steps-circle').querySelectorAll('.effect input').forEach(input => {
                    if (input.value === 0 || input.value === "" || input.value === null) {
                        input.classList.remove('focus');
                    } else {
                        input.classList.add('focus');
                    }
                })
            }
        });

        this.submitBtn.on('click', (e) => {
            e.preventDefault();
            let formHelper = new ME_FormHelper(this.stepsCircleForm.find('.step-final'));
            let finalStep = formHelper.formValidate();


            if (!finalStep) {
                window.scrollBy({
                    top: (-(this.stepsCircleForm.find('.step-final').offset().top / 2) - 100),
                    behavior: 'smooth'
                })
            }

            if (finalStep) {
                this.stepsCircleForm.submit()
            }
        });
    }
}
